import React from "react";

import { useCaseFromPath } from "./utils/hooks";

// A case that isn't found gets the conveyancing page, which says so
const ByCaseType = ({ conveyancing: Conveyancing, probate: Probate }) =>
  useCaseFromPath()?.case_type === "probate" ? <Probate /> : <Conveyancing />;

export default ByCaseType;
